import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  admins: [],
  adminById: null,
  adminsLoading: false,
  adminsError: '',
};

const adminsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_ADMINS_REQUEST:
    case AC.GET_ADMIN_DETAILS_REQUEST:
    case AC.ADD_ADMIN_REQUEST:
    case AC.EDIT_ADMIN_REQUEST:
    case AC.DELETE_ADMIN_REQUEST:
      return updateObject(state, {adminsLoading: true, adminsError: ''});
    case AC.GET_ADMINS_SUCCEED:
      return updateObject(state, {
        admins: action.payload,
        adminsLoading: false,
      });
    case AC.GET_ADMIN_DETAILS_SUCCEED:
      return updateObject(state, {
        adminById: action.payload,
        adminsLoading: false,
      });
    case AC.GET_ADMINS_FAILED:
    case AC.GET_ADMIN_DETAILS_FAILED:
    case AC.ADD_ADMIN_FAILED:
    case AC.EDIT_ADMIN_FAILED:
    case AC.DELETE_ADMIN_FAILED:
      return updateObject(state, {
        adminsError: action.payload,
        adminsLoading: false,
      });
    default:
      return state;
  }
};

export default adminsReducer;
